import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import JobForm from "../components/JobForm";

export default class WorkHistoryStep extends TalentAppStep {
    static path = '/work-history';
    static LastUpdatedMethod = 'lastUpdatedWorkHistory';

    static HasRequirements = true;
    /**
     * The title shown on the form
     */
    static StepTitle = TB.trans('talent.work_history.step_title');
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = TB.trans('talent.work_history.step_subtitle');
    /**
     * The start page info tile
     */
    static StepInfo = TB.trans('talent.work_history.step_info');
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Resume';
    /**
     * show completion icon on sidebar
     */
    static NeedsCompletion = (user) => {
        return user.isOnTalentMarketplace();
    };
    /**
     * Show brief details for user
     */
     static ProfileSectionSummary = (user) => {
        if(!this.hasCompleted(user)) return false;
        return `${user.jobs?.length} Jobs`;
    };

    static hasCompleted(user) {
        if (!user.isOnTalentMarketplace()) {
            return true;
        }
        let items = TB.filter(user.jobs || [], item => TB.isDefined(item?.employer))
        return items.length > 0;
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        return user.validateWorkHistory()
    };

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        if (!user.isOnTalentMarketplace()) {
            return false;
        }
        if (!user.validateWorkHistory() || !TB.filter(user?.jobs || [], job => !!job?.id)?.length) {
            return this;
        }

        return false;
    };

    /**
     * Render the form
     *
     * @returns {Form}
     */
    renderFormFooter() {

        return (
            <div className="pb-6">
                {this.renderChildForm({
                    displayName: TB.trans('talent.work_history.company_form_display_name'),
                    ChildFormComponent: JobForm,
                    userProp: 'jobs'
                })}

            </div>
        );
    }
    /**
     * Are requirements optional
     *
     * @returns boolean
     */
    isRequirementOptional() {
        return !this.props.authUser?.isOnTalentMarketplace();
    }
    /**
     * Are requirements completed?
     *
     * @returns boolean
     */
    isRequirementComplete() {
        return !this.props.authUser.isOnTalentMarketplace() ||
            TB.filter(this.props.authUser?.jobs || [], job => !!job?.id)?.length >= 1;
    }
    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return this.props.authUser?.isOnTalentMarketplace() ?
            'At least 1 work history is required.' : 'Work History is optional and not required.';
    }
}